import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "layer-order-row" }
const _hoisted_2 = { class: "drag-handle" }

import { computed, type MaybeRef,  toValue, toRef } from 'vue';
import draggable from 'vuedraggable';
import M from 'maplibre-gl';

import { useMaplibreLayerOrderControl } from "@/composables/useMaplibreLayerOrderControl";
import { capitalizeWords } from "@/utils/names";

interface Props {
  mapRef: M.Map | null;
  order: MaybeRef<string[]>;
}

interface Emits {
  (e: 'change', newOrder: string[]): void;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'LayerOrderControl',
  props: {
    mapRef: {},
    order: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const mapRef = toRef(() => props.mapRef);

// https://vuejs.org/guide/typescript/composition-api.html#typing-component-emits

const _emit = __emit;
const { 
  currentOrder, 
  controller 
} = useMaplibreLayerOrderControl(mapRef, toValue(props.order), true);

const displayOrder = computed({
  get(): string[] {
    return currentOrder.value.slice().reverse();
  },
  set(value: string[]) {
    controller?.setOrder(value.slice().reverse());
  }
});

const layerNames: Record<string, string | undefined> = {
  "tempo-no2": "TEMPO NO2",
  "aqi-layer-aqi": "Air Quality Index",
  "power-plants-heatmap": "Power Plants",
  "power-plants-layer": "Power Plants",
  "stamen-toner-lines": "Roads",
  "pop-dens": "Population Density",
  "land-use": "Land Use",
  "hms-fire": "Fire Detections",
  'tempo-hcho': "TEMPO HCHO",
  'tempo-o3': "TEMPO Ozone",
};

const layerInfo: Record<string, string | undefined> = {
  "aqi-layer-aqi": 'From <a href="https://www.airnow.gov/aqi/aqi-basics/">EPA</a>; taken once per day',
};

function displayNameTransform(layerId: string): string {
  return layerNames[layerId] ?? capitalizeWords(layerId.replace(/-/g, " "));
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_layer_control_item = _resolveComponent("layer-control-item")!

  return (_openBlock(), _createBlock(_unref(draggable), {
    modelValue: displayOrder.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayOrder).value = $event)),
    handle: ".drag-handle",
    class: "layer-order",
    "item-key": (item) => item
  }, {
    item: _withCtx(({ element }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-menu", -1)
            ]))]),
            _: 1
          })
        ]),
        _createVNode(_component_layer_control_item, {
          map: mapRef.value,
          "layer-id": element,
          info: layerInfo[element],
          "display-name": displayNameTransform(element)
        }, null, 8, ["map", "layer-id", "info", "display-name"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "item-key"]))
}
}

})